module.exports = __webpack_public_path__ + "img/usecase_enterprise_05.a0bbbdab.jpg";